import { IRolePerrmission } from "./AccessDomainModels";
import * as Fetch from "../../utils/Fetch"

export interface IUserAccessDataRow {
	
	resourceId: number,
	kind: string,
	applicationName: string,
	name: string,
	label: string,
	type: string,
	login: string,
	environment: string,
	passwordExist: boolean,
	personAccountDescription: string,
	personAccountType: string,
	company: string,
	referenceNumber: string,
	systemName: string,
	telephone: string,
	email: string,
	location: string,

	expirationDate: string,
	inceptionDate: string,
	issueId: number,
	relationId: number,
	resourceStatus: string,
	relationStatus: string,
	followFromPersonProfile: boolean,

	system: string,
	period: string,
	rolePermission: string,
	role: IRolePerrmission,
	sensitiveData: boolean,
	reasonForProcessingSensitiveData: string,
}

export interface IDictionary<TValue> {
	[id: number]: TValue;
}

interface GetRelatedAccessesResult {
	Kind: string;
	ApplicationName: string;
	Name: string;
	Label: string;

	Type: string;
	Login: string;
	Environment: string;
	PasswordExist: boolean;
	PersonAccountDescription: string;
	PersonAccountType: string;
	Company: string;
	Telephone: string;
	Email: string;
	Location: string;
	ReferenceNumber: string;
	SystemName: string;

	ExpirationDate: string;
	ResourceId: number;
	InceptionDate: string;
	IssueId: number | null;
	RelationId: number;
	Role: IRolePerrmission;
	ResourceStatus: string;
	RelationStatus: string;
	FollowFromPersonProfile: boolean;
}

export default class AccessUserAccessesService {
	load(userId: string, filterId: string, servicesFilters: string, applicationsFilters: string, setRowsPerUsers: (result: IUserAccessDataRow[]) => void) {
		Fetch.get<any>("/ResourceRelations/GetRelatedAccesses", {
			userId: userId,
			filterId: filterId,
			servicesFilters: servicesFilters,
			applicationsFilters: applicationsFilters,
		})
			.then(data => {
				if (data.success) {
					var result = data.rows.map((row: GetRelatedAccessesResult) => {
						let newRow: IUserAccessDataRow = {
							applicationName: row.ApplicationName,
							environment: row.Environment,
							expirationDate: row.ExpirationDate,
							followFromPersonProfile: row.FollowFromPersonProfile,
							inceptionDate: row.InceptionDate,
							issueId: row.IssueId,
							kind: row.Kind,
							login: row.Login,
							name: row.Name,
							label: row.Label,
							passwordExist: row.PasswordExist,
							period: row.InceptionDate,
							personAccountDescription: row.PersonAccountDescription,
							personAccountType: row.PersonAccountType,
							company: row.Company,
							telephone: row.Telephone,
							email: row.Email,
							location: row.Location,
							referenceNumber: row.ReferenceNumber,
							relationId: row.RelationId,
							resourceId: row.ResourceId,
							relationStatus: row.RelationStatus,
							resourceStatus: row.ResourceStatus,
							role: row.Role,
							rolePermission: "",
							sensitiveData: row.Role?.sensitiveData,
							reasonForProcessingSensitiveData: row.Role?.reasonForProcessingSensitiveData,
							system: (row.ApplicationName || "") + " " + row.Name,
							systemName: row.SystemName,
							type: row.Type,
						}
						if (row.Role)
							newRow.rolePermission = row.Role.name;

						return newRow;
					});
					setRowsPerUsers(result);
					return;
				}
				console.error("Nie udało się pobrać danych.");
				setRowsPerUsers(null);
			});
	}
}